import { unauthedRequest } from "./requests";

/**
 *
 * /registrations resource requests
 *
 */
export const postRegistration = ({ email, password }) =>
  unauthedRequest("v2/registrations", {
    method: "POST",
    body: JSON.stringify({
      user: {
        email,
        password,
      }
    })
  });

export const verifyRegistration = ({ payload }) => 
 unauthedRequest(`v2/confirmations?confirmation_token=${payload}`, {}).then(r => r);





// WEBPACK FOOTER //
// ./src/utils/api/registrations.js